"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLoginHistory_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Location_1 = require("./Location");
var User_1 = require("./User");
var UserLoginHistory_Factory = /** @class */ (function () {
    function UserLoginHistory_Factory() {
    }
    UserLoginHistory_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            IPIn: model.IPIn,
            IsLoginSuccess: model.IsLoginSuccess,
            Location: Location_1.Location_Factory.CreateIncoming(model.Location),
            LocationId: model.LocationId,
            LogIn: Date_Factory_1.Date_Factory.CreateIncoming(model.LogIn),
            LogOut: Date_Factory_1.Date_Factory.CreateIncoming(model.LogOut),
            Offset: model.Offset,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            ScheduleFrom: model.ScheduleFrom,
            SchedulerFeature: model.SchedulerFeature,
            ScheduleTo: model.ScheduleTo,
            User: User_1.User_Factory.CreateIncoming(model.User),
            UserId: model.UserId,
            UserSpecificHoursId: model.UserSpecificHoursId,
        };
        return result;
    };
    UserLoginHistory_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            IPIn: model.IPIn,
            IsLoginSuccess: model.IsLoginSuccess,
            Location: Location_1.Location_Factory.CreateOutgoing(model.Location),
            LocationId: model.LocationId,
            LogIn: Date_Factory_1.Date_Factory.CreateOutgoing(model.LogIn),
            LogOut: Date_Factory_1.Date_Factory.CreateOutgoing(model.LogOut),
            Offset: model.Offset,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            ScheduleFrom: model.ScheduleFrom,
            SchedulerFeature: model.SchedulerFeature,
            ScheduleTo: model.ScheduleTo,
            User: User_1.User_Factory.CreateOutgoing(model.User),
            UserId: model.UserId,
            UserSpecificHoursId: model.UserSpecificHoursId,
        };
        return result;
    };
    return UserLoginHistory_Factory;
}());
exports.UserLoginHistory_Factory = UserLoginHistory_Factory;
